$(function () {
  $('a[href]').each(function () {
    if($(this).attr('href') == null || $(this).attr('href') == undefined || $(this).attr('href') == false) {
      this.removeAttribute('href');
    }
  })
})
